import { z } from 'zod';
import { Gender } from '../enums.js';

export const createPatientSchema = z.object({
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  birth_date: z.string().min(1),
  email: z.email(),
  phone: z.string().min(1),
  gender: z.enum(Gender),
});

export type CreatePatientPayload = z.infer<typeof createPatientSchema>;
